import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { authAPI } from '@/services/api';
import { MailWarning, RefreshCcw } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

export default function VerifyEmailBanner() {
	const { t } = useTranslation();
	const { user } = useAuth();
	const [sending, setSending] = useState(false);
	const [sent, setSent] = useState(false);

	if (!user) return null;
	if (user.email_verified !== false) return null; // hides for verified users + grandfathered (undefined treated as verified upstream)

	const resend = async () => {
		setSending(true);
		try {
			await authAPI.resendVerification();
			setSent(true);
			toast.success(t('verify.resent'));
		} catch (e) {
			toast.error(e?.response?.data?.detail || t('verify.failed'));
		}
		setSending(false);
	};

	return (
		<div
			className="bg-[#FFF7E6] border border-[#D4AF37]/40 rounded-sm p-4 flex items-start gap-3"
			data-testid="verify-email-banner"
		>
			<MailWarning className="w-5 h-5 text-[#8B4513] flex-shrink-0 mt-0.5" />
			<div className="flex-1 min-w-0">
				<p className="text-sm font-semibold text-[#1A3C34]">{t('verify.banner_title')}</p>
				<p className="text-xs text-[#666055] mt-0.5">
					{t('verify.banner_body')} <strong className="text-[#1A3C34]">{user.email}</strong>
				</p>
			</div>
			<Button
				size="sm"
				variant="outline"
				onClick={resend}
				disabled={sending || sent}
				className="border-[#8B4513]/40 text-[#8B4513] hover:bg-[#8B4513]/10 rounded-sm h-9 text-xs flex-shrink-0"
				data-testid="resend-verification-btn"
			>
				<RefreshCcw className="w-3 h-3 mr-1" />
				{sending ? t('common.loading') : sent ? t('verify.sent_short') : t('verify.resend')}
			</Button>
		</div>
	);
}